import { HaftpflichtSchaden } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';
import { Omit } from '../../helpers/omit.helper';
import { HaftpflichtAdditional } from '../shared-models/haftpflichtschaden.model';

export const TYPE_HAFTPFLICHT_GESCHAEDIGTE_PERSON = 'HAFTPFLICHT-GESCHAEDIGTE-PERSON';

export interface HaftpflichtGeschaedigtePersonAdditional extends Omit<HaftpflichtAdditional, 'docTypBelege' | 'kundeList'> {
  detailsNachbringen?: boolean;
}

export interface HaftpflichtGeschaedigtePersonModelConfig extends DynamicFormValueControlModelConfig<HaftpflichtSchaden> {
  additional?: HaftpflichtGeschaedigtePersonAdditional;
}

export class HaftpflichtGeschaedigtePersonModel extends DynamicFormValueControlModel<HaftpflichtSchaden> {
  @serializable() readonly type: string = TYPE_HAFTPFLICHT_GESCHAEDIGTE_PERSON;
  @serializable() additional: HaftpflichtGeschaedigtePersonAdditional;

  constructor(config: HaftpflichtGeschaedigtePersonModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
    // additional is set in super
  }
}
